import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CornerBrandingComponent } from '../corner-branding/corner-branding.component';
import { LocationSearchComponent } from '../location-search/location-search.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { InfoTabComponent } from '../info-tab/info-tab.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    CornerBrandingComponent,
    LocationSearchComponent,
    NavBarComponent,
    InfoTabComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DataTablesModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  exports: [
    CornerBrandingComponent,
    LocationSearchComponent,
    NavBarComponent,
    InfoTabComponent,
    DataTablesModule,
  ],
})
export class SharedModule {}
